export default "__VITE_ASSET__DNKW$VRD__ 800w";